import { ArrowUpLeft, CodeXml, Mail, Phone } from "lucide-react";
import { Link, useLocation } from "react-router";

export function PublicFooter() {
  const { pathname } = useLocation();
  const topic = pathname === "/signup" ? "signup" : pathname === "/subscription" ? "subscription" : "login";
  const publicPages = ["/login", "/signup", "/subscription", "/forgot_password", "/support", "/zoooz-policy", "/rate-limited", "/payment-verify"];
  const from = publicPages.includes(pathname) ? pathname : "/support";

  return (
    <footer dir="rtl" className="relative mt-auto w-full shrink-0 border-t border-zoooz-primary/10 bg-gradient-to-l from-purple-50/90 to-white text-zoooz-text">
      <div className="mx-auto flex max-w-6xl flex-col gap-5 px-5 py-5 sm:px-8 md:flex-row md:items-center md:justify-between">
        <div className="flex min-w-0 items-start gap-3">
          <span className="mt-1 flex size-9 shrink-0 items-center justify-center rounded-xl border border-zoooz-primary/10 bg-white text-zoooz-primary" aria-hidden="true">
            <CodeXml className="size-4" />
          </span>
          <div className="min-w-0">
            <p className="text-xs text-slate-500">פיתוח וטכנולוגיה</p>
            <a href="mailto:office@software-berti-tech.com" className="mt-1 inline-block text-sm font-bold text-zoooz-text! hover:text-zoooz-primary!" dir="ltr">
              Berti Tech <span className="font-normal">Software Solutions LTD</span>
            </a>
            <div className="mt-2 flex flex-wrap items-center gap-x-4 gap-y-2 text-xs text-slate-500" dir="ltr">
              <a href="mailto:office@software-berti-tech.com" className="inline-flex items-center gap-1.5 text-inherit! hover:underline">
                <Mail className="size-3.5 shrink-0" aria-hidden="true" />office@software-berti-tech.com
              </a>
              <a href="tel:+972509191227" className="inline-flex items-center gap-1.5 text-inherit! hover:underline">
                <Phone className="size-3.5 shrink-0" aria-hidden="true" />050-919-1227
              </a>
            </div>
          </div>
        </div>
        {pathname !== "/support" && <div className="flex items-center justify-between gap-4 border-t border-zoooz-primary/10 pt-4 md:border-0 md:pt-0">
          <p className="text-xs leading-5 text-slate-500">בעיה בהתחברות, בהרשמה או במנוי?<br />אנחנו כאן כדי לעזור.</p>
          <Link to={`/support?topic=${topic}`} state={{ from }} className="inline-flex min-h-11 shrink-0 items-center gap-2 rounded-xl border border-zoooz-primary/15 bg-white px-4 text-sm font-semibold text-zoooz-primary! transition-colors hover:bg-purple-50 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-zoooz-primary">
            פנייה לתמיכה<ArrowUpLeft className="size-4" aria-hidden="true" />
          </Link>
        </div>}
      </div>
    </footer>
  );
}
